import { render, staticRenderFns } from "./OpenCasesGrid.vue?vue&type=template&id=a0bbb91c&scoped=true&"
import script from "./OpenCasesGrid.vue?vue&type=script&lang=js&"
export * from "./OpenCasesGrid.vue?vue&type=script&lang=js&"
import style0 from "./OpenCasesGrid.vue?vue&type=style&index=0&id=a0bbb91c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bbb91c",
  null
  
)

export default component.exports